import axios from 'axios';


const url = process.env.REACT_APP_BASE_API_URL;

export const monitorLimitesFindBySitId = async(sitid) => {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.get(url + `/v1/monitorlimites/findbysitid/${sitid}`, {headers});
}

export const monitorLimitesInsert = async(payLoad) => {
  const headers = { 'Content-Type': 'application/json'};
  return await axios.post(url + '/v1/monitorlimites/insert', payLoad, {headers});
  }

  export const monitorLimitesUpdate = async(payLoad) => {
    const headers = { 'Content-Type': 'application/json'};
    return await axios.put(url + '/v1/monitorlimites/update', payLoad, {headers});
  }
    
  export const monitorLimitesDelete = async (sitid, motid) =>{
    console.log('monitorLimitesDelete', sitid, motid);
    const headers = { 'Content-Type': 'application/json'};
    return await axios.delete(url + `/v1/monitorlimites/delete/${sitid}/${motid}`, {headers});
  }
